
  const getSideMenuHtml = () => {
    const menuDataRaw = localStorage.getItem('meganav-menu-items');
    if (!menuDataRaw) return null;

    try {
      const menuData = JSON.parse(menuDataRaw);
      const { parentNodeData, parentMenuData, isSideMenuApplied, clickedItem } = menuData;

      const listItems = parentMenuData
        .map((item) => {
          const activeClass = clickedItem.url == item.data.url ? 'parent--current' : '';
          return `
        <li class="sub-category parent ${activeClass}">
          <a href="${item.data.url}" data-category="${item.data.handle}" data-handle="${item.data.handle}">
            ${item.data.title}
          </a>
        </li>
      `;
        })
        .join('');

      const html = `
      <ul>
        <li>
          <a href="${parentNodeData.url}" class="title">${parentNodeData.title}</a>
          <ul class="sub-categories">
            ${listItems}
          </ul>
        </li>
      </ul>
    `;

      return {
        html,
        newSideMenuTitle: parentNodeData.title,
        isSideMenuApplied,
      };
    } catch (error) {
      console.error('Failed to parse meganav menu data:', error);
      return null;
    }
  };

  const updateSideMenu = () => {
    const sidebar = document.querySelector('.product-list .sidebar-navigation');
    if (!sidebar) return;

    const sideMenuData = getSideMenuHtml();
    if (!sideMenuData) return;

    const currentTitleEl = sidebar.querySelector('.title');
    const currentTitle = currentTitleEl ? currentTitleEl.textContent.trim() : '';

    const isTitleDifferent = currentTitle !== sideMenuData.newSideMenuTitle;
    const isNotApplied = sideMenuData.isSideMenuApplied === false;

    if (isTitleDifferent && isNotApplied) {
      sidebar.innerHTML = sideMenuData.html;

      setTimeout(() => {
        subCategoryClickEvent();
      }, 400);
    }
  };

  updateSideMenu();

  const subCategoryClickEvent = () => {
    const subCategories = document.querySelectorAll('.sidebar-navigation .sub-categories .sub-category a');
    subCategories.forEach((subCategory) => {
      subCategory.addEventListener('click', (e) => {
        const menuDataRaw = localStorage.getItem('meganav-menu-items');
        if (!menuDataRaw) return;
        const menuDataJson = JSON.parse(menuDataRaw);
        updateSubcategoryActiveState(subCategory);
        menuDataJson.clickedItem = getItemData(subCategory);
        localStorage.setItem('meganav-menu-items', JSON.stringify(menuDataJson));
      });
    });
  };
  subCategoryClickEvent();
